export const VISIBLE_QUARTERS = 4;
export const EXPORT_VISIBLE_QUARTERS = 4;
export const LEGEND_WIDTH_FRACTION = 0.2;
export const MIN_LEGEND_WIDTH = 250;
export const CHART_LEGEND_WIDTH = 80;
export const ARROW_WIDTH = 60;
export const LEGEND_TOP_OFFSET = 30;
export const LEGEND_BOTTOM_OFFSET = 0;
